// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorElementButton_container__1i_zn","colorBox":"ColorElementButton_colorBox__3zdGW"};